import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { fluxInputOutline, fluxInputSizes } from "../flux/variants.js";
export const DatePicker = React.forwardRef(({ className = "", invalid = false, inputSize = "base", ...rest }, ref) => {
    return (_jsx("input", { ref: ref, type: "date", "data-invalid": invalid ? "true" : undefined, className: [fluxInputOutline, fluxInputSizes[inputSize], "min-w-0", className].join(" "), ...rest }));
});
DatePicker.displayName = "DatePicker";
